import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const HIDE_LOADING_OVERLAY = '[AppUiActions] HIDE_LOADING_OVERLAY';
export const SHOW_LOADING_OVERLAY = '[AppUiActions] SHOW_LOADING_OVERLAY';
export const SHOW_LOCK_SCREEN = '[AppUiActions] SHOW_LOCK_SCREEN';
export const HIDE_LOCK_SCREEN = '[AppUiActions] HIDE_LOCK_SCREEN';
export const SHOW_EXIT_SCREEN = '[AppUiActions] SHOW_EXIT_SCREEN';
export const HIDE_EXIT_SCREEN = '[AppUiActions] HIDE_EXIT_SCREEN';
export const SHOW_PAUSE_SCREEN = '[AppUiActions] SHOW_PAUSE_SCREEN';
export const HIDE_PAUSE_SCREEN = '[AppUiActions] HIDE_PAUSE_SCREEN';
export const SHOW_GENERIC_PAGE = '[AppUiActions] SHOW_GENERIC_PAGE';
export const HIDE_GENERIC_PAGE = '[AppUiActions] HIDE_GENERIC_PAGE';
export const TOGGLE_NAVIGATION_MODAL_VISIBILITY = '[AppUiActions] TOGGLE_NAVIGATION_MODAL_VISIBILITY';

export class HideLoadingOverlay implements Action {
  readonly type = HIDE_LOADING_OVERLAY;
  constructor() { }
}

export class ShowLoadingOverlay implements Action {
  readonly type = SHOW_LOADING_OVERLAY;
  constructor() { }
}

export class ShowLockScreen implements Action {
  readonly type = SHOW_LOCK_SCREEN;
  constructor() { }
}

export class HideLockScreen implements Action {
  readonly type = HIDE_LOCK_SCREEN;
  constructor() { }
}

export class ShowPauseScreen implements Action {
  readonly type = SHOW_PAUSE_SCREEN;
  constructor() { }
}

export class HidePauseScreen implements Action {
  readonly type = HIDE_PAUSE_SCREEN;
  constructor() { }
}

export class ShowExitScreen implements Action {
  readonly type = SHOW_EXIT_SCREEN;
  constructor() { }
}

export class HideExitScreen implements Action {
  readonly type = HIDE_EXIT_SCREEN;
  constructor() { }
}
export class ShowGenericPage implements Action {
  readonly type = SHOW_GENERIC_PAGE;
  readonly payload: { title: string, content: string, isNonRecoverable: boolean, redirectUrl?: string, visible: boolean };
  constructor(title: string, content: string, isNonRecoverable: boolean, redirectUrl?: string) {
    this.payload = {
        title: title,
        content: content,
        visible: true,
        isNonRecoverable: isNonRecoverable,
        redirectUrl: redirectUrl
      };
  }
}

export class HideGenericPage implements Action {
  readonly type = HIDE_GENERIC_PAGE;
  constructor() { }
}

export class ToggleNavigationModal implements Action {
  readonly type = TOGGLE_NAVIGATION_MODAL_VISIBILITY;
  constructor(public visible: boolean) { }
}

export type All
  = HideLoadingOverlay
  | ShowLoadingOverlay
  | ShowLockScreen
  | HideLockScreen
  | ShowExitScreen
  | HideExitScreen
  | ShowPauseScreen
  | HidePauseScreen
  | ShowGenericPage
  | HideGenericPage
  | ToggleNavigationModal
  ;



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/actions/app-ui.action.ts